import React, { useCallback, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { Typography, Stack, styled } from "@mui/material";
import {
  Root,
} from "@/common/Styled/CommonStyled";
import TitleBox from "../CommonComponent/TitleBox";
import { useToast } from '../../components/useToast';
import { DATE_UTIL } from "@/common/util/date.util";
import { COMMON_UTIL } from "@/common/util/common.util";
import { isAgreePush } from "../../nativebridge/JsToNative";
import { NativeToJsBridge, NativeToJsEventName } from "../../nativebridge/NativeToJs";
import CommonSwitch from "@/views/CommonComponent/Styled/CommonSwitch";

const OsAlertSetting = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  height: 56,
  alignItems: 'center',
  backgroundColor: '#fffcf0',
  borderRadius: 8,
  padding: '8px 16px',
  boxSizing: 'border-box',
}));

function PushAgree(props) {
  const history = useHistory();
  const { authStore, userStore } = props;
  const { intl } = props;
  const { showDeleteToast } = useToast();

  useEffect(() => {
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onSetPushAgree,
      async (event) => {
        const isAgree = event.isAgree;
        console.log("========NativeToJs=========== isAgree=" + isAgree);
        userStore.updateUserPushAgreement(authStore.loginUser.id, isAgree, () => {
          if (!isAgree) {
            const now = new Date();
            const formattedDate = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}`;
            showDeleteToast(
              <span style={{ whiteSpace: "pre-line" }}>
                {intl.formatMessage({ id: "Toast_marketing_notification_off" })} {/* 푸시 알림을 거부했습니다. */}
                &nbsp;{formattedDate}
              </span>
            );
          }
        });
      }
    );

    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onSetPushAgree
      );
    };
  }, []);

  const handleBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleMarketingToggle = (event) => {
    const isChecked = event.target.checked;
    userStore.updateUserPushAgreement(authStore.loginUser.id, isChecked, () => userStore.getUserPushAgreement(authStore.loginUser.id, () => {
      if (COMMON_UTIL.isWebView()) {
        isAgreePush(userStore.userPushAgreement.agreed ? 1 : 0);
      }
    }));

    // 현재 날짜를 YYYY. MM. DD 형식으로 설정
    const now = new Date();
    const formattedDate = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}`;

    // 토스트 메시지 표시
    if (isChecked) {
      showDeleteToast(
        <span style={{ whiteSpace: "pre-line" }}>
          {intl.formatMessage({ id: "Toast_marketing_notification_on" })} {/* 푸시 알림을 동의했습니다. */}
          &nbsp;{formattedDate}
        </span>
      );
    } else {
      showDeleteToast(
        <span style={{ whiteSpace: "pre-line" }}>
          {intl.formatMessage({ id: "Toast_marketing_notification_off" })} {/* 푸시 알림을 거부했습니다. */}
          &nbsp;{formattedDate}
        </span>
      );
    }
  };

  const isPushAgreed = () => {
    if (userStore.userPushAgreement === '') {
      return false;
    } else {
      if (userStore.userPushAgreement.agreed) {
        return true;
      } else {
        return false;
      }
    }
  }

  return (
    <Root>
      <TitleBox
        title={intl.formatMessage({ id: "push_alert" })} /* 푸시 알림 */
        subtitle={intl.formatMessage({ id: "marketing_notification_description" })}
        onBack={handleBack}
      />
      <Stack alignItems="center" p={2} mt={4} gap={5}>
        <Stack alignItems="center" width="100%" gap={0.5}>
          <Stack direction="row" justifyContent="space-between" width="100%">
            <Typography variant="body1">
              {intl.formatMessage({ id: "marketing_notification" })} {/* 포코로가 보내는 소식 */}
            </Typography>
            <CommonSwitch
              checked={isPushAgreed()}
              onChange={handleMarketingToggle}
            />
          </Stack>
          {userStore.userPushAgreement === '' ? (
            <Typography variant="body2" color="#909195" width="100%">
              {intl.formatMessage({ id: "marketing_notification_off" })} {/* 수신거부 */}
            </Typography>
          ) : userStore.userPushAgreement.agreed ? (
            <Typography variant="body2" color="#909195" width="100%">
              {intl.formatMessage({ id: "marketing_notification_on" })} {/* 수신동의 */}
              {DATE_UTIL.convertUTCToTimeZone(userStore.userPushAgreement.updatedDatetime, 'YYYY. MM. DD')}
            </Typography>
          ) : (
            <Typography variant="body2" color="#909195" width="100%">
              {intl.formatMessage({ id: "marketing_notification_off" })} {/* 수신거부 */}
              {DATE_UTIL.convertUTCToTimeZone(userStore.userPushAgreement.updatedDatetime, 'YYYY. MM. DD')}
            </Typography>
          )}
        </Stack>
        {/* <OsAlertSetting> */}
        {/* <Typography variant="body2"> */}
        {/* {intl.formatMessage({ id: "marketing_notification_setting_txt" })} 실시간으로 소식을 받기 위해 OS설정에서 알림을 켜주세요.   */}
        {/* </Typography> */}
        {/* <Stack direction="row" gap={0.5} alignItems="center" width="32%" justifyContent="flex-end"> */}
        {/* <Typography variant="body2" fontWeight="bold"> */}
        {/* {intl.formatMessage({ id: "marketing_notification_setting_btn" })} 설정 이동 */}
        {/* </Typography> */}
        {/* <Icon icon="weui:arrow-outlined" fontSize={20} fontWeight="bold"/> */}
        {/* </Stack> */}
        {/* </OsAlertSetting> */}
      </Stack>
    </Root>
  );
}

export default injectIntl(inject("authStore", "userStore")(observer(PushAgree)));
